import HideTransition from "./HideTransition";
import $ from 'jquery'
class DropdownList {
    element = null
    selectors = {
        list: '.js-drop-down__list',
        dropDownButton: '.js-drop-down__button'
    }
    defaults = {
        isVisible: true
    }

    constructor(element, options= {}) {
        this.element = element
        this.element._dropdown = this
        this.selectors = {...this.selectors, ...options.selectors}
        this.defaults = {...this.defaults, ...options.defaults}
        this.dropDownSwithcer = new HideTransition(this.dropDownListElement[0], this.dropDownButtonElement[0])
        this.toggleList(!(this.isDropDownButtonVisible && !this.defaults.isVisible))
    }

    toggleList(value) {
        if (typeof value === 'boolean') {
            value === true ? this.dropDownSwithcer?.showEl() : this.dropDownSwithcer?.hideEl()
        }
    }


    get isDropDownButtonVisible () {
        return this.dropDownButtonElement[0].offsetWidth
            || this.dropDownButtonElement[0].offsetHeight
            || this.dropDownButtonElement[0].getClientRects().length
    }

    get dropDownListElement () {
        return $(this.element).find(this.selectors.list)
    }

    get dropDownButtonElement () {
        return $(this.element).find(this.selectors.dropDownButton)
    }
}

$('.js-drop-down').each((index, item) => {
    new DropdownList(item)
})
